import { AiOutlineCloudDownload } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
import { baseClasses } from './Button';

export const UploadImageButton = ({ loading, onImageSelect }) => {
  const baseStyle = twMerge(
    baseClasses,
    'cursor-pointer bg-gradient-to-r from-contrast2 to-contrast1 text-font1 hover:bg-gradient-to-l',
  );

  const loadingStyle = twMerge(baseClasses, 'bg-gray-300 text-font1 cursor-wait');

  return (
    <label htmlFor="dropzone-file" className={`${loading ? loadingStyle : baseStyle} `}>
      <AiOutlineCloudDownload />
      {loading ? 'Завантаження ...' : 'Додати'}
      <input
        id="dropzone-file"
        onChange={onImageSelect}
        name="photo"
        disabled={loading}
        type="file"
        className="hidden w-full h-full"
        accept=".jpg, .jpeg, .png"
      />
    </label>
  );
};
